// extracted by mini-css-extract-plugin
export default {"main":"Login_main__enLui","part1":"Login_part1__vo0ll"};